<template>
  <avs-card>
    <template v-slot:title>
      <v-card-title class="pl-0"
        >{{ $t("commons.edit") }} {{ get_type(fieldtype.component.name) }}</v-card-title
      >
    </template>
    <template v-slot:content>
      <v-container>
        <v-form
          :readonly="!isEditable"
          ref="form"
        >
          <CompanyOwnedInput
            v-model="$store.getters['app/getCompany']"
            :rules="rules.company"
            outlined
            disabled
          />
          <!-- <v-text-field
            v-if="inTemplate"
            v-model="nameField"
            :rules="rules.nameField"
            :label="$t('commons.name')"
            counter="64"
            maxlength="64"
            outlined
            dense
          > 
          </v-text-field>-->
          <v-text-field
            v-if="inTemplate"
            v-model="nameField"
            :rules="rules.nameField"
            :label="$t('commons.name')"
            counter="1000"
            maxlength="1000"
            outlined
            dense
          ></v-text-field>

          <v-text-field
            v-model="fieldtype.name"
            :rules="rules.name"
            :label="$t('commons.type')"
            counter="64"
            maxlength="64"
            outlined
            dense
          ></v-text-field>

          <v-textarea
            v-model="fieldtype.description"
            :rules="rules.description"
            :label="$t('commons.description')"
            outlined
            dense
          ></v-textarea>

          <v-combobox
            v-model="fieldtype.options.items"
            :rules="rules.optionsItems"
            @keyup.enter="uppercase"
            :hint="$t('views.template.hint.type_enter')"
            :label="$t('commons.values')"
            maxLength="1024"
            persistent-hint
            deletable-chips
            small-chips
            multiple
            hide-selected
            outlined
          ></v-combobox>

          <v-col class="d-flex justify-end gap-4">
            <avs-saveButton
              @click="save"
              :disabled="!isEditable"
            />
            <avs-cancelButton @click="cancel" />
          </v-col>
        </v-form>
      </v-container>
    </template>
  </avs-card>
</template>

<script>
import { CompanyOwnedInput } from "@/components"
import { FieldTypeService } from "@/services/documents"
import { isEqual } from "@/utils/object"
import { required, slug, max64 } from "@/utils/validator"

import _ from "lodash"

export default {
  name: "SelectorFieldEditor",
  components: { CompanyOwnedInput },
  props: {
    component: {
      type: Object,
      required: true
    },
    hasUniqueName: {
      type: Function,
      required: true
    },
    inTemplate: {
      type: Boolean,
      default: false
    },
    isEditable: {
      type: Boolean,
      default: true
    },
    value: {
      type: Object
    }
  },
  computed: {
    fieldtype: {
      get() {
        return _.cloneDeep(this.value || this.getDefaultValue())
      }
    }
  },
  data() {
    return {
      rules: {
        company: [required],
        description: [],
        // name: [required, slug, this.hasUniqueName, max64],
        // nameField: [required, slug, max64],
        // nameField: [required, max64],
        nameField: [required],
        name: [required, slug, this.hasUniqueName, max64],
        optionsItems: [required]
      },
      nameField: null
    }
  },
  created() {},
  methods: {
    uppercase() {
      let last = this.fieldtype.options.items.pop()
      if (last) {
        last = last.toUpperCase()
        if (!this.fieldtype.options.items.includes(last)) {
          this.fieldtype.options.items.push(last)
        }
      }
    },
    getDefaultValue() {
      return {
        name: "",
        description: "",
        options: { items: [] },
        component: this.component,
        company: this.$store.state.app.user.companies[0] || null
      }
    },
    cancel() {
      this.$emit("cancel")
    },
    get_type(item) {
      if (item.toLowerCase() == "selector") {
        return this.$t("commons.selector")
      } else if (item.toLowerCase() == "table") {
        return this.$t("commons.table")
      } else if (item.toLowerCase() == "checkbox") {
        return this.$t("commons.checkbox")
      } else if (item.toLowerCase() == "textfield") {
        return this.$t("commons.textfield")
      } else if (item.toLowerCase() == "imagefield") {
        return this.$t("commons.imagefield")
      } else if (item.toLowerCase() == "textarea") {
        return this.$t("commons.textarea")
      } else {
        return this.$t("commons.datefield")
      }
    },
    async performSave(data) {
      if (data.id > 0) {
        return FieldTypeService.put(data)
      } else {
        data.company = this.$store.getters["app/getCompany"]
        return FieldTypeService.post(data)
      }
    },
    async save() {
      if (this.$refs.form.validate()) {
        if (isEqual(this.fieldtype, this.value)) {
          // Objects are equal, no changes to perform
          this.$emit("success")
        } else {
          this.performSave(this.fieldtype)
            .then(response => {
              this.$emit("input", response)
              if (this.inTemplate) {
                this.$emit("success", { name: this.nameField, type: response })
              } else {
                this.$emit("success")
              }
            })
            .catch(error => {
              const message = error?.response.data?.state
              this.$emit("error", message)
            })
        }
      }
    }
  }
}
</script>
